import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteFinanceEntry } from '@services/registry';

export function useDeleteFinanceEntry({ tenantId }) {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: async ({ entryId }) => {
            return await deleteFinanceEntry({ tenantId, entryId });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['financeSummary', tenantId] });
            qc.invalidateQueries({ queryKey: ['financeAccounts', tenantId] });
            qc.invalidateQueries({ queryKey: ['financeEntries', tenantId] });
        },
    });
}

